/* ------------------------------------------------------------------------
Copyright (c) 2016, VoiceVibes, Inc

VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
All contents of this file are proprietary and confidential. No part of
any of the contents of this file may be disclosed in any manner to
a third party without the prior written consent of VoiceVibes, Inc.
Unauthorized copying of this file, via any medium is strictly prohibited.
----------------------------------------------------------------------------- */

<template>
  <div
    v-if="saving"
    class="tab-well text-center"
  >
    <h2>
      <svg
        class="icon-refresh rotate large-spinner"
      >
        <use xlink:href="/static/svg-symbols.svg#icon-refresh" />
      </svg>
      Saving...
    </h2>
    <br><br><br>
  </div>
  <div
    v-else
    class="col-lg-12"
    style="margin-bottom: 20px;"
  >
    <h1>
      <router-link
        :to="{ name: (managerLevel) ? 'coach-dashboard' : 'speaker-dashboard' }"
      >
        Dashboard
      </router-link>
      |
      {{ assignment.name }}
    </h1>
    <div
      :class="collapsed ? 'assignment-preview preview-collapsed' : 'assignment-preview'"
    >
      <div class="form-group">
        <svg
          v-if="collapsed"
          class="icon-chevron-down"
          @click.prevent="collapse"
        >
          <use xlink:href="/static/svg-symbols.svg#icon-chevron-down" />
        </svg>
        <svg
          v-else
          class="icon-chevron-up"
          @click.prevent="collapse"
        >
          <use xlink:href="/static/svg-symbols.svg#icon-chevron-up" />
        </svg>
        <h4 style="margin: 0; padding: 0;">
          <!-- eslint-disable-next-line -->
          <svg v-if="!isTemplate && managerLevel && assignment.groupTargets && assignment.groupTargets.length" class="assignmentIcon" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <!-- eslint-disable-next-line -->
            <rect width="18" height="18" rx="2" fill="#F26724"/>
            <!-- eslint-disable-next-line -->
            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.70638 7.02625L6 6.30176C7.75512 4.56386 10.3813 4.5683 12.0671 6.30176L11.3607 7.02625C9.98261 5.79506 8.01514 5.79506 6.70638 7.02625ZM9.03348 9.4442C9.99121 9.4442 10.7669 10.2398 10.7669 11.2221C10.7669 12.2044 9.99121 13 9.03348 13C8.07574 13 7.30002 12.2044 7.30002 11.2221C7.30002 10.2398 8.07574 9.4442 9.03348 9.4442ZM9.0335 10.3331C8.5568 10.3331 8.16678 10.7332 8.16678 11.2221C8.16678 11.711 8.5568 12.1111 9.0335 12.111C9.5102 12.111 9.90023 11.711 9.90023 11.2221C9.90023 10.7332 9.5102 10.3331 9.0335 10.3331ZM8.18844 8.51969C8.69981 8.14634 9.36285 8.14633 9.87422 8.51969L10.6066 7.77298C9.73121 6.87514 8.40945 6.87514 7.45605 7.77298L8.18844 8.51969Z" fill="white"/>
            <!-- eslint-disable-next-line -->
            <path d="M17.1129 7.91066C17.0603 7.79854 16.9479 7.72733 16.8251 7.72733H15.8811C15.2818 4.47349 12.4246 2 9 2C5.14011 2 2 5.14043 2 9C2 12.8596 5.14011 16 9 16C11.4906 16 13.8139 14.6593 15.0624 12.5016C15.2387 12.1978 15.1346 11.8082 14.8304 11.632C14.5256 11.4564 14.1367 11.5598 13.9608 11.8646C12.9388 13.6299 11.0382 14.728 9 14.728C5.84185 14.727 3.27267 12.1585 3.27267 9C3.27267 5.84185 5.84185 3.27299 8.99968 3.27299C11.72 3.27299 13.9985 5.1807 14.5791 7.72733H13.6431C13.5197 7.72733 13.4079 7.79886 13.3548 7.91066C13.3023 8.02246 13.3203 8.15424 13.3986 8.24929L14.9896 10.1586C15.0502 10.2311 15.1401 10.2727 15.2341 10.2727C15.3285 10.2727 15.4175 10.2308 15.4784 10.1586L17.0694 8.24929C17.1483 8.15424 17.1657 8.02246 17.1129 7.91066Z" fill="white"/>
          </svg>
          <!-- eslint-disable-next-line -->
          <svg v-else-if="!isTemplate && managerLevel" class="assignmentIcon" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <!-- eslint-disable-next-line -->
            <rect width="18" height="18" rx="2" fill="#F26724"/>
            <!-- eslint-disable-next-line -->
            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.30115 6.03938L4.24158 4.95263C6.87426 2.34579 10.8135 2.35245 13.3422 4.95263L12.2826 6.03938C10.2155 4.19258 7.26429 4.19258 5.30115 6.03938ZM8.79186 9.6663C10.2285 9.6663 11.392 10.8597 11.392 12.3331C11.392 13.8066 10.2285 15 8.79186 15C7.35526 15 6.19168 13.8066 6.19168 12.3331C6.19168 10.8597 7.35526 9.6663 8.79186 9.6663ZM8.79189 10.9997C8.07684 10.9997 7.4918 11.5998 7.4918 12.3332C7.4918 13.0665 8.07684 13.6666 8.79189 13.6666C9.50694 13.6666 10.092 13.0665 10.092 12.3332C10.092 11.5998 9.50694 10.9997 8.79189 10.9997ZM7.52423 8.27954C8.29129 7.7195 9.28586 7.7195 10.0529 8.27954L11.1515 7.15946C9.8384 5.8127 7.85576 5.8127 6.42566 7.15946L7.52423 8.27954Z" fill="white"/>
          </svg>

          <router-link
            v-if="managerLevel && !assignment.isGlobal"
            :to="{ name: 'edit-assignment',
                   params: {assignmentId: assignment.assignmentId, stepNum: assignmentStepsByName.description } }"
            style="font-size: 18px"
          >
            {{ assignment.name }}
          </router-link>
          <span
            v-else
            style="font-size: 18px"
          >
            {{ assignment.name }}
          </span>
        </h4>
        <span
          v-if="!assignment.isTemplate"
          class="assignment-status"
        >
          Status: {{ getStatus(assignment) | capitalize }}
        </span>
        <hr style="margin: 4px;">
        <h4>
          <router-link
            v-if="managerLevel && !assignment.isGlobal"
            :to="{ name: 'edit-assignment',
                   params: {assignmentId: assignment.assignmentId, stepNum: assignmentStepsByName.description } }"
          >
            Description
          </router-link>
          <span v-else>
            Description
          </span>
        </h4>
        <!-- eslint-disable-next-line -->
        <span class="ass-description">{{ assignment.description }}</span>
      </div>
      <hr>
      <div>
        <h4>
          <router-link
            v-if="managerLevel && assignment.isTemplate && !assignment.isGlobal"
            :to="{ name: 'edit-assignment',
                   params: {assignmentId: assignment.assignmentId, stepNum: assignmentStepsByName.criteria } }"
          >
            Criteria
          </router-link>
          <span v-else>
            Criteria
          </span>
        </h4>
        <div
          class="form-group"
          style="font-weight: 400;"
        >
          <div v-if="isPersistentAssignment">
            None / Persistent Assignment
          </div>
          <div v-if="assignment.criteria.minRecordings">
            <svg
              v-if="criteriaCompletion['minRecordings']"
              class="icon-check-circle"
            >
              <use xlink:href="/static/svg-symbols.svg#icon-check-circle" />
            </svg>
            <svg
              v-else
              class="icon-circle"
            >
              <use xlink:href="/static/svg-symbols.svg#icon-circle" />
            </svg>
            Record at least {{ assignment.criteria.minRecordingsCount }} recording(s)
          </div>
          <div v-if="assignment.criteria.minRatingNum">
            <svg
              v-if="criteriaCompletion['minRating']"
              class="icon-check-circle"
            >
              <use xlink:href="/static/svg-symbols.svg#icon-check-circle" />
            </svg>
            <svg
              v-else
              class="icon-circle"
            >
              <use xlink:href="/static/svg-symbols.svg#icon-circle" />
            </svg>
            Receive a coach overall rating of at least {{ assignment.criteria.minRatingNum }}
          </div>
          <div v-if="assignment.criteria.minScoreNum">
            <svg
              v-if="criteriaCompletion['minScore']"
              class="icon-check-circle"
            >
              <use xlink:href="/static/svg-symbols.svg#icon-check-circle" />
            </svg>
            <svg
              v-else
              class="icon-circle"
            >
              <use xlink:href="/static/svg-symbols.svg#icon-circle" />
            </svg>
            Receive an automated Vocal Delivery score of at least {{ assignment.criteria.minScoreNum }}
          </div>
          <div v-if="assignment.criteria.managerReview">
            <svg
              v-if="criteriaCompletion['managerReview']"
              class="icon-check-circle"
            >
              <use xlink:href="/static/svg-symbols.svg#icon-check-circle" />
            </svg>
            <svg
              v-else
              class="icon-circle"
            >
              <use xlink:href="/static/svg-symbols.svg#icon-circle" />
            </svg>
            Flag one recording for manager review
          </div>
          <div v-if="assignment.criteria.shareRecording">
            <svg
              v-if="criteriaCompletion['shareRecording']"
              class="icon-check-circle"
            >
              <use xlink:href="/static/svg-symbols.svg#icon-check-circle" />
            </svg>
            <svg
              v-else
              class="icon-circle"
            >
              <use xlink:href="/static/svg-symbols.svg#icon-circle" />
            </svg>
            Share at least 1 recording with the group
          </div>
          <div v-if="assignment.criteria.selfCommentary">
            <svg
              v-if="criteriaCompletion['selfCommentary']"
              class="icon-check-circle"
            >
              <use xlink:href="/static/svg-symbols.svg#icon-check-circle" />
            </svg>
            <svg
              v-else
              class="icon-circle"
            >
              <use xlink:href="/static/svg-symbols.svg#icon-circle" />
            </svg>
            Add self-commentary via a feedback comment you leave on your own recording
          </div>
        </div>
      </div>
      <div
        v-if="assignment.criteria.wordspotting && managerLevel && assignment.wordspotting && !assignment.isGlobal"
      >
        <hr>
        <h4>
          <router-link
            :to="{ name: 'edit-assignment',
                   params: {assignmentId: assignment.assignmentId, stepNum: assignmentStepsByName.wordspotting } }"
          >
            Custom Wordspotting List
          </router-link>
        </h4>
        <br>
        <wordspotting-list :words="assignment.wordspotting" />
      </div>

      <div
        v-if="assignment.scorecard && managerLevel && !assignment.isGlobal"
      >
        <hr>
        <h4>
          <router-link
            :to="{ name: 'edit-assignment',
                   params: {assignmentId: assignment.assignmentId, stepNum: assignmentStepsByName.scorecard } }"
          >
            Custom Scorecard
          </router-link>
        </h4>
      </div>

      <div
        v-if="assignment.attachments && assignment.attachments.length"
      >
        <hr>
        <h4>
          <router-link
            v-if="managerLevel && !assignment.isGlobal"
            :to="{ name: 'edit-assignment',
                   params: {assignmentId: assignment.assignmentId, stepNum: assignmentStepsByName.attachments } }"
          >
            Supporting Materials
          </router-link>
          <span v-else>
            Supporting Materials
          </span>
        </h4>
        <br>
        <assignment-attachment-list
          :assignment="assignment"
          :show-trash-can="false"
        />
        <br>
      </div>

      <!-- This prevents the attachment list from overflowing its container -->
      <div class="row" />

      <div v-if="managerLevel">
        <div
          v-if="assignment.isTemplate && !assignment.isGlobal"
        >
          <hr>
          <h4>{{ assignment.isShared ? 'Public' : 'Private' }} Template</h4>
          <div v-if="showTemplateSharing">
            <a
              href="#"
              class="indented-link"
              @click.prevent="applyAction('togglePrivacy')"
            >
              Make {{ !assignment.isShared ? 'Public' : 'Private' }}
            </a>
            <tooltip
              placement="right"
              trigger="hover"
              :content="!assignment.isShared ?
                `Making this template public will share the template with all the coaches in the ${$store.getters.org.name} organization.` :
                'Making this template private ensures only you will have access to it.'"
            >
              <span>
                <svg
                  class="icon-help-circle"
                >
                  <use xlink:href="/static/svg-symbols.svg#icon-help-circle" />
                </svg>
              </span>
            </tooltip>
          </div>
        </div>

        <div
          v-if="!assignment.isTemplate && assignment.groupTargets && assignment.groupTargets.length"
        >
          <hr>
          <h4>Assignment Type</h4>
          <span style="font-size: 14px;">
            Continuous, assigned to Group &quot;{{ group.name }}&quot;
          </span>
          <a
            href="#"
            class="indented-link"
            @click.prevent="applyAction('Deactivate')"
          >
            Turn Off Continuous Status
          </a>
          <tooltip
            placement="right"
            trigger="hover"
            content="When you change the assignment type from Continuous to Non-Continuous, new users who join the group
              will no longer automatically receive the assignment. Existing users will still
              be prompted to complete it."
          >
            <span>
              <svg
                class="icon-help-circle"
              >
                <use xlink:href="/static/svg-symbols.svg#icon-help-circle" />
              </svg>
            </span>
          </tooltip>
        </div>

        <div
          v-if="!assignment.isTemplate && (!assignment.groupTargets || !assignment.groupTargets.length)"
        >
          <hr>
          <h4>Assignment Type</h4>
          Non-Continuous Assignment
          <a
            href="#"
            class="indented-link"
            @click.prevent="applyAction('Reactivate')"
          >
            Convert Assignment to Continuous
          </a>
          <tooltip
            placement="right"
            trigger="hover"
            content="When you change the assignment type from Non-Continuous to Continuous, new users who join the group
              will automatically receive the assignment. Additionally, all existing users in the group
              who do not yet have the assignment will receive it."
          >
            <span>
              <svg
                class="icon-help-circle"
              >
                <use xlink:href="/static/svg-symbols.svg#icon-help-circle" />
              </svg>
            </span>
          </tooltip>
        </div>
        <hr style="margin-top: 5px !important;">
        <br>
        <router-link
          v-if="!assignment.isGlobal"
          :to="{ name: 'edit-assignment',
                 params: {assignmentId: assignment.assignmentId, stepNum: assignmentStepsByName.description } }"
        >
          <button
            class="btn btn-primary"
            type="submit"
          >
            Edit {{ (isTemplate) ? 'Template' : 'Assignment' }}
          </button>
        </router-link>

        <span
          v-if="isTemplate && !assignment.isGlobal"
          tabindex="0"
          class="delete-link"
          aria-label="delete this template"
          role="button"
          @click.prevent="applyAction('Delete')"
          @keypress="applyAction('Delete')"
        >
          Delete
          <svg class="svgicon icon-trash">
            <use xlink:href="/static/svg-symbols.svg#icon-trash" />
          </svg>
        </span>
        <span v-else-if="!assignment.archived && !assignment.isGlobal">
          <a
            href="#"
            class="indented-link"
            @click.prevent="applyAction('Archive')"
          >
            Archive Assignment
          </a>
          <tooltip
            placement="right"
            trigger="hover"
            content="Archived assignments will be hidden for coaches, and marked disabled for speakers."
          >
            <span>
              <svg
                class="icon-help-circle"
              >
                <use xlink:href="/static/svg-symbols.svg#icon-help-circle" />
              </svg>
            </span>
          </tooltip>
        </span>
        <span v-else-if="assignment.archived && !assignment.isGlobal">
          <a
            href="#"
            class="indented-link"
            @click.prevent="applyAction('Unarchive')"
          >
            Restore Archived Assignment
          </a>
          <tooltip
            placement="right"
            trigger="hover"
            content="Restoring an archived assignment results in it no longer being marked as disabled for speakers."
          >
            <span>
              <svg
                class="icon-help-circle"
              >
                <use xlink:href="/static/svg-symbols.svg#icon-help-circle" />
              </svg>
            </span>
          </tooltip>
        </span>
        <span class="mobile-spacer" />
        <span class="mobile-spacer" />
        <tooltip
          placement="right"
          trigger="hover"
          :content="assignment.isTemplate ? 'Create a new copy of this template.' : `Copying this assignment will result in a new template, which can then be assigned.\nA template for this assignment probably already exists so it may be better to use that than to create a new one.`"
        >
          <a
            href="#"
            class="copyButton"
            @click.prevent="copy()"
          >
            {{ assignment.isTemplate ? 'Copy Template' : 'Copy as Template' }}
            <svg
              class="icon-copy"
            >
              <use xlink:href="/static/svg-symbols.svg#icon-copy" />
            </svg>
          </a>
        </tooltip>
        <span v-if="!assignment.isTemplate && !assignmentLinkEnabled">
          <a
            href="#"
            class="indented-link"
            @click.prevent="showAssignmentLink()"
          >
            Show Assignment Link
            <svg
              class="icon-link"
            >
              <use xlink:href="/static/svg-symbols.svg#icon-link" />
            </svg>
          </a>
        </span>
        <router-link
          :class="(!assignment.isGlobal) ? 'indented-link2' : ''"
          :to="{ name: 'edit-assignment',
                 params: {assignmentId: assignment.assignmentId, stepNum: assignmentStepsByName.assignment } }"
        >
          <button
            v-if="isTemplate"
            class="btn btn-primary"
            type="submit"
          >
            Assign This
          </button>
        </router-link>
        <span
          v-if="assignment.isGlobal"
          style="margin-left: 12px;"
        >
          You can edit this template, as needed, after you have assigned it.
        </span>
        <div
          v-if="assignmentLinkEnabled"
          id="assignmentLinkContainer"
        >
          You can copy and paste this link to share this assignment with any user who has already
          had it assigned to them.
          <input
            v-model="assignmentLink"
            type="text"
            class="form-control"
            style="width: 400px"
          >
        </div>
      </div>
    </div>

    <div
      v-if="!managerLevel"
      class="recordingLinkContainer"
    >
      <router-link
        :to="{ name: 'record',
               query: {assignmentId: assignment.assignmentId } }"
      >
        <svg class="svgicon icon-record">
          <use xlink:href="/static/svg-symbols.svg#icon-record" />
        </svg><span> {{ recordForThisAssignmentText }}</span>
      </router-link>
    </div>

    <div
      v-if="assignment.userTargets && assignment.userTargets.length"
      style="margin-top: 20px;"
    >
      <div class="row">
        <div
          v-if="managerLevel || group.speakerPrivacyLevel !== 4"
          class="col-sm-4"
        >
          <h3
            style="margin-top: 0; font-size: 24px;"
          >
            Assigned to {{ (group.speakerPrivacyLevel === 3 && !managerLevel) ? '' : assignment.userTargets.length }}
            User{{ assignment.userTargets.length == 1 ? '' : 's' }}
            in Group: {{ group.name }}
          </h3>
        </div>
        <div
          class="col-sm-8"
        >
          <div
            style="font-size: 10px;"
          >
            MEMBERS
          </div>
          <span class="assmembers-filter">
            <span
              :class="{ active: assPreviewFilter == 'all' }"
              @click.prevent="loadFilter('assPreview', 'all')"
            >
              All
            </span>
            |
            <span
              v-if="managerLevel"
              :class="{ active: assPreviewFilter == 'submitted' }"
              @click.prevent="loadFilter('assPreview', 'submitted')"
            >
              Flagged for Review
            </span>
            <span
              v-else
              :class="{ active: assPreviewFilter == 'shared' }"
              @click.prevent="loadFilter('assPreview', 'shared')"
            >
              Peer Shared
            </span>
            |
            <span
              :class="{ active: assPreviewFilter == 'active' }"
              @click.prevent="loadFilter('assPreview', 'active')"
            >
              Active
            </span>
            |
            <span
              :class="{ active: assPreviewFilter == 'completed' }"
              @click.prevent="loadFilter('assPreview', 'completed')"
            >
              Completed
            </span>
          </span>
          <!--  Download Report Button  -->
          <a
            v-if="managerLevel"
            id="download-report-btn"
            class="btn"
            @click.capture.prevent="preDownloadReport()"
          >
            <svg
              class="icon-dl-report"
              style="height: 27px; width: 27px;"
            >
              <use xlink:href="/static/svg-symbols.svg#icon-dl-report" />
            </svg>
            <div style="text-align: left;">
              Download<br>Report
            </div>
          </a>
        </div>
      </div>
      <h3
        v-if="!filteredMembers || !filteredMembers.length"
      >
        No users found
      </h3>
      <table
        v-if="filteredMembers && filteredMembers.length"
        :key="assPreviewKey"
        class="ass-members-table newTable table table-bordered"
      >
        <thead>
          <tr>
            <th
              width="20%"
              scope="col"
              class="sortable"
              @click.prevent="sortTable('assPreview', 'name')"
            >
              Name
              <svg
                v-if="assPreviewSort == 'name-d' || assPreviewSort == 'name-u'"
                class="icon-arrow"
              >
                <use :xlink:href="(assPreviewSort == 'name-d') ? '/static/svg-symbols.svg#icon-arrow-down' : '/static/svg-symbols.svg#icon-arrow-up'" />
              </svg>
            </th>
            <th
              width="15%"
              scope="col"
              class="sortable"
              @click.prevent="sortTable('assPreview', 'status')"
            >
              Speaker Assignment Status
              <svg
                v-if="assPreviewSort == 'status-d' || assPreviewSort == 'status-u'"
                class="icon-arrow"
              >
                <use :xlink:href="(assPreviewSort == 'status-d') ? '/static/svg-symbols.svg#icon-arrow-down' : '/static/svg-symbols.svg#icon-arrow-up'" />
              </svg>
            </th>
            <th
              width="20%"
              scope="col"
              class="sortable"
              @click.prevent="sortTable('assPreview', 'lastUpload')"
            >
              Last Upload
              <svg
                v-if="assPreviewSort == 'lastUpload-d' || assPreviewSort == 'lastUpload-u'"
                class="icon-arrow"
              >
                <use :xlink:href="(assPreviewSort == 'lastUpload-d') ? '/static/svg-symbols.svg#icon-arrow-down' : '/static/svg-symbols.svg#icon-arrow-up'" />
              </svg>
            </th>
            <th
              v-if="managerLevel"
              width="15%"
              scope="col"
              class="sortable"
              @click.prevent="sortTable('assPreview', 'recordings')"
            >
              Recordings
              <svg
                v-if="assPreviewSort == 'recordings-d' || assPreviewSort == 'recordings-u'"
                class="icon-arrow"
              >
                <use :xlink:href="(assPreviewSort == 'recordings-d') ? '/static/svg-symbols.svg#icon-arrow-down' : '/static/svg-symbols.svg#icon-arrow-up'" />
              </svg>
            </th>
            <th
              v-if="managerLevel || group.speakerPrivacyLevel !== 4"
              width="15%"
              scope="col"
              class="sortable"
              @click.prevent="sortTable('assPreview', managerLevel ? 'submittedRecordings' : 'sharedRecordings')"
            >
              {{ managerLevel ? 'Recordings Flagged for Review' : 'Recordings Shared with Group' }}
              <svg
                v-if="assPreviewSort == 'submittedRecordings-d' || assPreviewSort == 'submittedRecordings-u' || assPreviewSort == 'sharedRecordings-d' || assPreviewSort == 'sharedRecordings-u'"
                class="icon-arrow"
              >
                <use :xlink:href="(assPreviewSort == 'submittedRecordings-d' || assPreviewSort == 'sharedRecordings-d') ? '/static/svg-symbols.svg#icon-arrow-down' : '/static/svg-symbols.svg#icon-arrow-up'" />
              </svg>
            </th>
            <th
              width="15%"
              scope="col"
              class="sortable"
              @click.prevent="sortTable('assPreview', 'comments')"
            >
              Comments
              <svg
                v-if="assPreviewSort == 'comments-d' || assPreviewSort == 'comments-u'"
                class="icon-arrow"
              >
                <use :xlink:href="(assPreviewSort == 'comments-d') ? '/static/svg-symbols.svg#icon-arrow-down' : '/static/svg-symbols.svg#icon-arrow-up'" />
              </svg>
            </th>
          </tr>
        </thead>
        <tbody
          v-for="speaker in filteredMembers"
          v-if="showSpeaker(speaker)"
        >
          <tr
            :class="getSpeakerClass(speaker)"
          >
            <td scope="row">
              <a
                v-if="speaker.recordings && speaker.recordings.length > 0"
                href="#"
                @click.prevent="expandRow('assPreviewKey', 'assPreview.user1', speaker.userId)"
              >
                {{ speaker.name }}
              </a>
              <span v-else>
                {{ speaker.name }}
              </span>
            </td>
            <td
              v-if="speaker.completionStatus.status == 'completed'"
              style="color: #04D97E;"
            >
              <svg
                class="icon-checkmark"
                style="fill: #04D97E;"
              >
                <use xlink:href="/static/svg-symbols.svg#icon-checkmark" />
              </svg> &nbsp;
              Completed
            </td>
            <td
              v-else-if="speaker.completionStatus.status == 'assigned'"
              style="color: #D3382F;"
            >
              <svg
                class="icon-eye-slash"
                style="fill: #D3382F;"
              >
                <use xlink:href="/static/svg-symbols.svg#icon-eye-slash" />
              </svg> &nbsp;
              Not Started
            </td>
            <td
              v-else
              style="color: #333;"
            >
              <svg class="icon-refresh">
                <use xlink:href="/static/svg-symbols.svg#icon-refresh" />
              </svg>
              In Progress
            </td>
            <td>{{ speaker.lastUpload | date }}{{ speaker.lastUpload ? '' : '-' }}</td>
            <td
              v-if="managerLevel"
            >
              {{ speaker.recordings ? speaker.recordings.length : 0 }}
            </td>
            <td
              v-if="managerLevel || group.speakerPrivacyLevel !== 4"
            >
              {{ managerLevel ? speaker.submittedRecordings : speaker.sharedRecordings }}
            </td>
            <td>{{ speaker.feedbackCount }}</td>
          </tr>
          <tr
            v-if="speaker.recordings && speaker.recordings.length > 0"
            v-show="isRowShown('assPreview.user1', speaker.userId)"
            :id="'speaker-recs-' + speaker.userId"
          >
            <td
              :colspan="managerLevel ? 6 : 5"
              class="well"
              style="padding-left:5%"
            >
              <table class="newTable table table-condensed table-bordered">
                <thead>
                  <tr>
                    <th
                      scope="col"
                    >
                      Recording
                    </th>
                    <th
                      scope="col"
                    >
                      History
                    </th>
                    <th
                      scope="col"
                    >
                      Duration
                    </th>
                    <th
                      scope="col"
                    >
                      Vocal Delivery
                    </th>
                    <th
                      scope="col"
                    >
                      Comments
                    </th>
                    <th
                      v-if="showOverallRating()"
                      scope="col"
                    >
                      {{ getOverallRatingHead(speaker) }}
                    </th>
                    <th
                      v-if="showCoachOverallRating(speaker)"
                      scope="col"
                    >
                      Coach Overall Rating
                    </th>
                  </tr>
                </thead>
                <tbody v-for="recording in speaker.recordings">
                  <tr>
                    <td scope="row">
                      <router-link
                        v-if="(currentUserId !== recording.userId)"
                        :to="{ name: 'evaluate-recording', params: { recordingId: recording.recordingId }, query: { assignmentId: assignment.assignmentId } }"
                      >
                        {{ recording.title }}
                      </router-link>
                      <router-link
                        v-if="(currentUserId === recording.userId)"
                        :to="{ name: 'evaluate-recording', params: { recordingId: recording.recordingId } }"
                      >
                        {{ recording.title }}
                      </router-link>
                    </td>
                    <td>
                      <nobr>{{ recording.createdDate | date }}</nobr>
                    </td>
                    <td>
                      <span v-if="recording.duration">
                        {{ recording.duration | time }}
                      </span>
                      <span v-else>
                        -
                      </span>
                    </td>
                    <td>
                      {{ (recording.results && recording.results.scores && recording.results.scores.overall) ? recording.results.scores.overall : 'N/A' }}
                    </td>
                    <td>
                      {{ recording.feedbackCount }}
                    </td>
                    <td
                      v-if="showOverallRating()"
                      rowspan="2"
                    >
                      <star-rating
                        inactive-color="#fff"
                        :increment="0.5"
                        :border-width="1"
                        border-color="#cccccc"
                        active-color="#EFA042"
                        :star-size="15"
                        :rating="recording.scoreOverallAvgRating / 2"
                        :read-only="true"
                        :show-rating="false"
                      />
                      (avg of {{ recording.numRatingsscoreOverall }} rating{{ recording.numRatingsscoreOverall == 1 ? '' : 's' }})
                    </td>
                    <td
                      v-if="showCoachOverallRating(speaker)"
                      rowspan="2"
                    >
                      <star-rating
                        inactive-color="#fff"
                        :increment="0.5"
                        :border-width="1"
                        border-color="#cccccc"
                        active-color="#EFA042"
                        :star-size="15"
                        :rating="recording.scoreOverallAvgRatingCoach / 2"
                        :read-only="true"
                        :show-rating="false"
                      />
                      (avg of {{ recording.numCoachRatingsscoreOverall }} rating{{ recording.numCoachRatingsscoreOverall == 1 ? '' : 's' }})
                    </td>
                  </tr>
                  <tr>
                    <td
                      :class="getRecordingClass(recording)"
                      style="padding-bottom: 0 !important;"
                    >
                      <audio
                        v-if="recording && recording.playbackUrl"
                        controls
                      >
                        <source
                          :src="recording.playbackUrl"
                          type="audio/mp3"
                        >
                      </audio>
                    </td>
                    <td
                      colspan="4"
                      :class="getRecordingClass(recording)"
                    >
                      <div
                        v-if="!managerLevel && user.userId == recording.userId"
                      >
                        <!-- SPEAKER VIEWING THEIR OWN RECORDING -->
                        <div v-if="recording.submitted">
                          <svg class="icon-flag">
                            <use xlink:href="/static/svg-symbols.svg#icon-flag" />
                          </svg>
                          Flagged for coach review
                          on {{ recording.submissionDate | date }},
                          <a
                            href="#"
                            @click.prevent="submit(recording, {recordingId: recording.recordingId, submitted: false})"
                          >
                            Undo
                          </a>
                          <br>
                        </div>
                        <div v-if="!recording.submitted">
                          <a
                            href="#"
                            @click.prevent="submit(recording, {recordingId: recording.recordingId, submitted: true})"
                          >
                            Flag recording for coach review
                          </a><br>
                        </div>
                        <div v-if="recording.feedbackRequested">
                          <svg class="icon-users">
                            <use xlink:href="/static/svg-symbols.svg#icon-users" />
                          </svg>
                          Shared with entire group on {{ recording.feedbackRequestedDate | date }},
                          <a
                            href="#"
                            @click.prevent="submit(recording, {recordingId: recording.recordingId, feedbackRequested: false})"
                          >
                            Undo
                          </a><br>
                        </div>
                        <div v-if="!recording.feedbackRequested && group.speakerPrivacyLevel !== 4">
                          <a
                            href="#"
                            @click.prevent="submit(recording, {recordingId: recording.recordingId, feedbackRequested: true})"
                          >
                            Share recording with entire group
                          </a><br>
                        </div>
                      </div>
                      <div v-else>
                        <div
                          v-if="recording.submitted"
                        >
                          <svg class="icon-flag">
                            <use xlink:href="/static/svg-symbols.svg#icon-flag" />
                          </svg>
                          <strong>
                            Flagged for coach review on {{ recording.submissionDate | date }}<br>
                          </strong>
                        </div>
                        <div
                          v-if="recording.feedbackRequested && group.speakerPrivacyLevel !== 4"
                        >
                          <svg class="icon-users">
                            <use xlink:href="/static/svg-symbols.svg#icon-users" />
                          </svg>
                          <strong>
                            Shared with entire group on {{ recording.feedbackRequestedDate | date }}
                          </strong>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td :colspan="getRatingsColspan(speaker)">
                      &nbsp;
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else-if="!isTemplate">
      There are currently no active users for this assignment.
    </div>

    <div
      v-if="managerLevel && !isTemplate"
      class="managerReports"
    >
      <h3 style="font-size: 24px;">
        Assignment Comparison Report
      </h3>
      <assignment-chart
        :assignment="assignment"
        :group="group"
      />
    </div>
  </div>
</template>

<style lang="less" scoped>
  @import '../../less/bootstrap-vars.less';
  @import '~bootstrap/less/mixins/buttons.less';

  .icon-arrow, .icon-circle, .icon-check-circle, .icon-flag, .icon-users,
  .icon-checkmark, .icon-eye-slash, .icon-refresh {
    width: 14px; height: 14px;
    position: relative;
    top: 2px;
  }

  a.copyButton, .delete-link {
    margin-left: 20px;
  }
  .icon-copy, .icon-link, .icon-trash {
    height: 17px;
    width: 17px;
    position: relative;
    top: 4px;
  }
  .icon-checkmark {
    fill: #04D97E;
  }
  .icon-eye-slash {
    fill: #D3382F;
  }
  .icon-refresh {
    fill: #333;
  }

  .icon-help-circle, .icon-copy, .icon-trash, .icon-link {
    fill: @brand-primary !important;
  }
  .icon-help-circle {
    margin-left: -1px !important;
  }

  .copyButton, .delete-link {
    color: #F26724;
  }
  hr.tab-spacer {
    margin: 5px;
    border-bottom: 1px solid #ccc;
    border-top: none;
  }
  @media (max-width: 768px) {
    .mobile-spacer {
      display: block;
      height: 15px;
    }
  }
  #download-report-btn {
    color: #5E5E5E;
    font-size: 12px !important;
    text-align: right;
    float: right;
    position: relative;
    bottom: 10px;
  }
  #download-report-btn:hover {
    color: darken(#5E5E5E, 20%);
  }
  #download-report-btn div {
    display: inline-block;
  }

  #assignmentLinkContainer {
    padding: 20px 0;
    input {
      margin-top: 5px;
    }
  }
  .managerReports {
    margin: 15px 0;
  }
  .recordingLinkContainer {
    margin: 15px;
    span {
      position: relative;
      bottom: 6px;
      left: 5px;
    }
  }

  @media (max-width: 646px) {
    #download-report-btn {
      display: none;
    }
  }

  .icon-chevron-down, .icon-chevron-up {
    float: right;
    cursor: pointer;
    height: 37px;
    width: 37px;
    color: #1e1d47;
    position: relative;
    bottom: 10px;
  }
  .ass-description {
    white-space: pre-line;
    padding: 0;
  }
  .assignment-preview {
    background-color: #f2f2f2;
    padding: 5px 20px 10px 20px;
    margin-top: 18px;
    border-radius: 8px;
    a, span {
      font-size: 12px;
    }
    h4 {
      font-size: 10px;
      text-transform: uppercase;
      font-weight: 400;
      span {
        font-weight: 400;
      }
    }
  }
  .preview-collapsed {
    height: 80px;
    overflow: hidden;
  }
  .icon-help-circle {
    cursor: pointer;
    margin-left: 5px;
    position: relative;
    top: 6px;
    height: 20px;
    width: 20px;
  }
  .assmembers-filter {
    color: @link-color;
    cursor: pointer;
    font-size: 14px;
  }
  .assmembers-filter span.active {
    color: #333;
    cursor: default;
  }
  td.submitted, tr.submitted {
    background-color: rgba(67, 183, 241, 0.1);
  }
  .criteriaList {
    list-style-type: none;
    li {
      line-height: 30px;
    }
  }
  .indented-link {
    margin-left: 30px;
  }
  .indented-link2 {
    margin-left: 60px;
  }
  th.sortable {
    cursor: pointer;
  }
  h4 {
    margin: 5px 0;
  }
  hr {
    border-bottom: 1px solid #ccc;
    margin: 0 !important;
  }
  .form-group {
    margin-bottom: 0px;
  }
  .attachment {
    padding: 10px;
    margin-right: 50px;
  }
  .assignmentIcon {
    position: relative;
    top: 2px;
  }
  .assignment-status {
    margin-top: 10px;
    font-size: 12pt;
  }
  .svgicon {
    display: inline-block;
    stroke-width: 0;
    stroke: currentColor;
    fill: currentColor;
  }
  .icon-record {
    width: 23px; height: 23px;
  }
  .ass-members-table th {
    text-transform: uppercase;
    font-weight: bold;
  }
</style>

<script>
import AssignmentAttachmentList from '../forms/AssignmentAttachmentList';
import WordspottingList from '../forms/WordspottingList';
import TableMethods from '../specials/TableMethods';
import StarRating from 'vue-star-rating';
import Tooltip from 'vue-strap/src/Tooltip';
import AssignmentChart from '../specials/AssignmentChart';
import DownloadReport from '../specials/DownloadReport';
import ScorecardMixin from '../specials/ScorecardMixin';
import AssignmentDataStructures from '../specials/AssignmentDataStructures';

export default {
  components: {WordspottingList, AssignmentAttachmentList, StarRating, Tooltip, AssignmentChart},
  mixins: [TableMethods, DownloadReport, AssignmentDataStructures, ScorecardMixin],
  props: [ 'assignment', 'managerLevel' ],
  data() {
    return {
      assPreview: 1,
      errors: [],
      saving: false,
      loaded: false,
      assPreviewFilter: 'all',
      assPreviewKey: 1,
      assPreviewSort: 'name-d',
      collapsed: this.$router.currentRoute.query.collapsed ? true : false,
      focusMyRecordings: this.$router.currentRoute.query.myRecordings ? true : false,
      assignmentLinkEnabled: false,
      assignmentLink: '',
    };
  },
  computed: {
    showTemplateSharing() {
      // New templates are never disabled
      if (!('userId' in this.assignment)) {
        return false;
      }
      return (this.$store.getters.user.userId == this.assignment.userId);
    },
    feedback() {
      return this.$store.getters.feedback;
    },
    speakers() {
      return this.assignment.members;
    },
    assignmentStepsByName() {
      return this.$store.getters.appConfig.assignmentStepsByName;
    },
    recordForThisAssignmentText() {
      if (!this.assignment.criteria || !this.assignment.criteria.algorithm) return 'Record for this Assignment';
      return this.assignment.criteria.algorithm.indexOf('conversational') === -1 ?
        'Record (Single Speaker)' : 'Record (Multi-Speaker)';
    },
    isPersistentAssignment() {
      const metaCriteria = this.$store.getters.appConfig.metaAssignmentCriteria;
      const activeCriteria = _.filter(
        this.assignment.criteria,
        (value, name) => {
          return metaCriteria.indexOf(name) === -1 && value === true;
        }
      );
      return _.size(activeCriteria) === 0;
    },
    // TODO: managedGroups and isGroupManager is only needed cuz of the bug where extra
    // ratings are returned for managers when in speaker mode
    managedGroups: {
      cache: false,
      get() {
        return this._.filter(this.$store.getters.activeGroups, group => {
          return this._.includes(group.roles, 'manager');
        });
      }
    },
    isAssignmentGroupManager() {
      if (!this.managedGroups.length > 0) {
        return false;
      }

      const grp = this._.find(this.managedGroups, {groupId: this.assignment.groupId});
      if (!grp || !grp.roles) return false;
      return grp.roles.indexOf('manager') !== -1;
    },
    user() {
      return this.$store.getters.user;
    },
    filteredMembers: {
      cache: false,
      get() {
        const filterFuncs = {
          submitted: (a) => {
            if (!a.recordings || !a.recordings.length) return false;
            const submitted = this._.find(a.recordings, (r) => r.submitted);
            return !!submitted;
          },
          shared: (a) => {
            if (!a.recordings || !a.recordings.length) return false;
            const shared = this._.find(a.recordings, (r) => r.feedbackRequested);
            return !!shared;
          },
          active: (a) => {
            return a.completionStatus.status !== 'completed';
          },
          all: () => {
            return true;
          },
          completed: (a) => {
            return a.completionStatus.status === 'completed';
          },
        };
        const members = [];
        this.assignment.members.forEach((member) => {
          const filterFunc = filterFuncs[this.assPreviewFilter] || filterFuncs['all'];
          if (filterFunc(member)) {
            members.push(member);
          }
        });

        return this.sortCollection(members, this.assPreviewSort);
      }
    },
    criteriaCompletion() {
      let criteriaCompletion = {};
      this._.forEach(this.assignment.userTargets, (u) => {
        if (u.userId == this.currentUserId) {
          criteriaCompletion = u.completionStatus;
        }
      });
      return criteriaCompletion;
    },
    isTemplate() {
      return !!(this.assignment.isTemplate);
    },
    currentUserId() {
      return this.$store.getters.user.userId;
    },
    groups() {
      return this.$store.getters.groups;
    },
    group: {
      cache: false,
      get() {
        return this.activeGroupsById[this.assignment.groupId];
      }
    },
    activeGroupsById: {
      cache: false,
      get() {
        return this.$store.getters.activeGroupsById;
      }
    },
  },
  created() {
    // Set the download report type
    this.r.config.reportType = 'assignment';
    this.r.config.showEmptyUsers = true;

    this.prepTableRowIndices();
    ['assPreviewFilter', 'assPreviewSort'].forEach((pref) => {
      if (this.preferences && this.preferences[pref]) {
        this[pref] = this.preferences[pref];
      }
    });

    // Check if we need to expand the current speaker
    if (this.focusMyRecordings) {
      window.setTimeout(() => {
        if (!this.isRowShown('assPreview.user1', this.user.userId)) {
          this.expandRow('assPreviewKey', 'assPreview.user1', this.user.userId);
        }
        const elem = document.getElementById('speaker-recs-' + this.user.userId);
        if (elem) elem.scrollIntoView(true);
      }, 1000);
    }
  },
  methods: {
    copy() {
      const confirmMsg = this.assignment.isTemplate ?
        'Make a copy of this template?' : 'Create a new template from this assignment?';
      if (window.confirm(confirmMsg)) {
        this.saving = true;
        this.getAssignmentSavePromises(
          [],
          null,
          {
            name: this.assignment.name + ' (Copy)',
            isTemplate: true,
            isShared: false,
            assignmentTemplateId: null,
            groupId: null,
          }
        ).then(
          () => {
            this.$store.dispatch(
              'updatePreferences',
              Object.assign(
                this.preferences,
                {coachDashboardToggle: 'templates', templateToggle: 'private'}
              )
            );
            const text = this.assignment.isTemplate ?
              'Template has been copied' : 'Assignment copied to a new template';
            this.$announcer.set(text);
            window.setTimeout(
              () => {
                this.$store.dispatch('notify', {
                  type: 'success',
                  subject: 'New Template Added',
                  text
                });
              },
              1000
            );
            this.$router.push({name: 'coach-dashboard'});
          }
        );
      }
    },
    showAssignmentLink() {
      this.assignmentLink = `https://app.myvoicevibes.com/assignment/details/${this.assignment.assignmentId}`;
      this.assignmentLinkEnabled = true;
    },
    showSpeaker(speaker) {
      if (speaker.userId == this.currentUserId) {
        // Always show your own
        return true;
      }
      if (this.isAssignmentGroupManager && this.managerLevel) {
        // Managers in manager mode always see everyone
        return true;
      }

      if (this.group.speakerPrivacyLevel === 3) {
        // On High Privacy, hide users with zero recordings
        if (!speaker.recordings || !speaker.recordings.length) return false;
      }

      // Otherwise, show everyone unless we are in speaker mode in SPL 4
      return !!(this.group.speakerPrivacyLevel !== 4);
    },
    getOverallRatingHead(speaker) {
      // Always show "Overall Rating" when viewing as a coach, or when
      // viewing your own recordings
      if (this.currentUserId === speaker.userId || this.managerLevel) {
        return 'Overall Rating';
      }

      // When viewing someone else's recordings as a speaker,
      // show "My Rating" for SPL 3, unless they are a coach
      return (this.group.speakerPrivacyLevel === 3 && !this.isAssignmentGroupManager) ?
        'My Rating' : 'Overall Rating';
    },
    collapse() {
      this.collapsed = !this.collapsed;
    },
    applyAction(action, evt) {
      if (evt && evt.key && evt.key === 'Tab') {
        // Firefox bug fix
        return true;
      }

      if (action == 'togglePrivacy') {
        if (!window.confirm(`Convert "${this.assignment.name}" to ${this.assignment.isShared ? 'private' : 'public'} template?`)) return false;
      } else if (action == 'Deactivate') {
        if (!window.confirm(`Turn off continuous status for assignment: ${this.assignment.name}?`)) return false;
      } else if (action == 'Reactivate') {
        if (!window.confirm(`Convert "${this.assignment.name}" to Continuous Group Assignment?`)) return false;
      } else {
        if (!window.confirm(`${action} assignment: ${this.assignment.name}?`)) return false;
      }

      let text;
      switch(action) {
      case 'Deactivate':
        text = 'Continuous status removed for the assignment';
        break;
      case 'Reactivate':
        text = 'Continuous status added to the assignment';
        break;
      case 'Delete':
      case 'Archive':
      case 'Unarchive':
        text = `The Assignment has been Successfully ${action}d`;
        break;
      case 'togglePrivacy':
        text = this.assignment.isShared ?
          'Template has been made private' : 'Template has been shared with all coaches in your org';
        break;
      }

      const postAction = () => {
        this.$announcer.set(text);
        this.$router.push({ name: 'coach-dashboard' });
        window.setTimeout(
          () => {
            this.$store.dispatch('notify', {
              type: 'success',
              subject: (action === 'togglePrivacy') ?
                'Template Modified' :
                'Assignment Status Changed',
              text
            });
          },
          1000
        );
      };

      if (action === 'Delete') {
        this.$store.dispatch('deleteAssignment', this.assignment).then(postAction);
      } else if (action === 'togglePrivacy') {
        this.assignment.isShared = !this.assignment.isShared;

        this.$store.dispatch(
          'updateAssignment',
          { assignment: this.assignment }
        ).then(postAction);
      } else if (action === 'Archive' || action === 'Unarchive') {
        this.assignment.archived = !!(action === 'Archive');

        this.$store.dispatch(
          'updateAssignment',
          { assignment: this.assignment, updateArchived: true }
        ).then(postAction);
      } else if (action === 'Deactivate' || action === 'Reactivate') {
        this.assignment.deactivated = !!(action === 'Deactivate');

        this.$store.dispatch(
          'updateAssignment',
          { assignment: this.assignment }
        ).then(postAction);
      }
    },
    getRatingsColspan(speaker) {
      const col1 = this.showOverallRating();
      const col2 = this.showCoachOverallRating(speaker);
      let colspan = 5;
      if (col1) colspan++;
      if (col2) colspan++;
      return colspan;
    },
    showOverallRating() {
      // Unless sharing is disabled completely, you are always allowed to see this column
      // since a speaker is always allowed to see their own ratings on other people's recordings
      return (this.group.speakerPrivacyLevel !== 4);
    },
    showCoachOverallRating(speaker) {
      if (this.managerLevel) return true;
      return (this.group.speakerPrivacyLevel >= 2 && speaker.userId != this.currentUserId) ? false : true;
    },
    getSpeakerClass(speaker) {
      let isSubmitted = false;
      this._.forEach(speaker.recordings, (r) => {
        if (r.submitted) {
          isSubmitted = true;
        }
      });

      if (this.managerLevel || speaker.userId == this.currentUserId) {
        return isSubmitted ? 'submitted' : '';
      }
      return '';
    },
    getRecordingClass(recording) {
      const isMine = !!(recording.userId == this.currentUserId);
      if (this.managerLevel || isMine) {
        return recording.submitted ? 'submitted' : '';
      }
      return '';
    },
    getStatus(assignment) {
      if (this.managerLevel) {
        if (assignment.archived || assignment.deleted) {
          return 'Disabled/Archived';
        }
        let baseStatus = (assignment.assignmentAssignedCount == assignment.assignmentCompletedCount &&
          (!assignment.groupTargets || !assignment.groupTargets.length)) ?
          'Completed' : 'Active';
        if (assignment.groupTargets && assignment.groupTargets.length) {
          baseStatus += ' (Continuous Group Assignment)';
        } else {
          baseStatus += ' (Non-Continuous Assignment)';
        }
        return baseStatus;
      }

      if (assignment.archived || assignment.deleted) {
        return 'Completed (Disabled by Your Coach)';
      }
      return assignment.completionStatus.status;
    },
    submit(recording, data) {
      this.$store.dispatch('updateRecording', data).then(() => {
        this.$store.dispatch(this.isManager ? 'listAssignments' : 'getAssignedAssignments').then(() => {
          // We need to manually update the recording cuz reactivity doesn't work. Grr...
          if (typeof data.submitted !== 'undefined') {
            recording.submitted = data.submitted;
            if (recording.submitted) {
              recording.submissionDate = new Date();
            }
          }
          if (typeof data.feedbackRequested !== 'undefined') {
            recording.feedbackRequested = data.feedbackRequested;
            if (recording.feedbackRequested) {
              recording.feedbackRequestedDate = new Date();
            }
          }
          this.assPreviewKey += 1;
        });
      });
    },
  }
};
</script>
